module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.5.4 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/group.html"
    }
  }, [_vm._v("Group")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] XSwitch：labelAlign support justify #1707")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/sticky.html"
    }
  }, [_vm._v("Sticky")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Auto re-bind after router-view transition is finished")]), _vm._v(" "), _c('li', [_vm._v("[fix] Fix position fixed not work in ios #1657")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/tabbar.html"
    }
  }, [_vm._v("Tabbar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add event:on-index-change #1715")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-img.html"
    }
  }, [_vm._v("XImg")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] re-init after router-view transition is finished")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/bus.html"
    }
  }, [_vm._v("Bus")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new plugin for managing events")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0cc4231b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-0cc4231b"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.5.4-117.vue
// module id = 2028
// module chunks = 277